/*
*###############################################################################
*Module Name                   : DPAlert.js                                    #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardBody, Button, Container } from "reactstrap"
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"


import questionmark from "../../assets/images/Icons/question.png"
import explanationmark from "../../assets/images/Icons/explanation.png"
import closemark from "../../assets/images/Icons/close.png"
import checkmark from "../../assets/images/Icons/checkmark.png"
import warningmark from "../../assets/images/Icons/warning.png"

const DPAlert = ({ confirm_both, title, description, onConfirm, onCancel, showCancel, btnColor, cancelColor, btnYes, btnNo, warning = false }) => {
    const htmlDesctiption = <span style={{ fontSize: 20 }}>{description}</span>


    useEffect(() => {
        const okButtonElement = document.getElementById('okButton');
        if (confirm_both && okButtonElement) {

            setTimeout(() => {
                okButtonElement.focus();
            }, 100);
        }
    }, [confirm_both]);


    return (
        <div>
            {confirm_both ? (
                <SweetAlert
                    title={title}
                    custom
                    style={{ width: '500px' }}
                    customIcon={showCancel ? questionmark : warning ? warningmark : explanationmark}
                    onConfirm={onConfirm}
                    customButtons={
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <Button
                                        id='okButton'
                                        color={btnColor}
                                        size="lg"
                                        onClick={onConfirm}
                                        className="d-flex align-items-center"
                                    >
                                        <img style={{ width: '20px', height: '20px', marginRight: '5px' }} src={checkmark} />
                                        <span>{btnYes ? btnYes : 'Yes'}</span>
                                    </Button>
                                </Col>
                                <Col hidden={showCancel === true ? false : true}>
                                    <Button color={cancelColor} size="lg" onClick={onCancel} className="d-flex align-items-center">
                                        <img style={{ width: '20px', height: '20px', marginRight: '5px' }} src={closemark} />
                                        <span>{btnNo ? btnNo : 'No'}</span>
                                    </Button>
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                >
                    {htmlDesctiption}
                </SweetAlert>
            ) : null}
        </div>
    );
}
// const DPAlert = ({ confirm_both, title, description, onConfirm, onCancel, showCancel, btnColor, cancelColor, btnYes, btnNo, warning = false }) => {


//     let htmlDesctiption = <span style={{ fontSize: 20 }}>{description}</span>

//     useEffect(() => {
//         const element = document.getElementById('okButton');
//         if (element) {
//             element.focus();
//         }
//     }, [confirm_both])


//     useEffect(() => {
//         const element = document.getElementById('okButton');
//         if (element) {
//             element.focus();
//         }
//     }, []);

//     return (
//         <div>
//             {confirm_both ? (

//                 <SweetAlert
//                     title={title}
//                     custom
//                     style={{ width: '500px' }}
//                     customIcon={showCancel ? questionmark : warning ? warningmark : explanationmark}
//                     customButtons={
//                         <React.Fragment>

//                             <Row>
//                                 <Col>
//                                     <Button id='okButton' color={btnColor} size="lg" onClick={onConfirm} className="d-flex align-items-center">
//                                         <img style={{ width: '20px', height: '20px', marginRight: '5px' }} src={checkmark} />
//                                         <span>{btnYes ? btnYes : 'Yes'}</span>
//                                     </Button>
//                                 </Col>
//                                 <Col hidden={showCancel === true ? false : true}>
//                                     <Button color={cancelColor} size="lg" onClick={onCancel} className="d-flex align-items-center">
//                                         <img style={{ width: '20px', height: '20px', marginRight: '5px' }} src={closemark} />
//                                         <span>{btnNo ? btnNo : 'No'}</span>
//                                     </Button>
//                                 </Col>
//                             </Row>

//                         </React.Fragment>
//                     }
//                 >
//                     {htmlDesctiption}
//                 </SweetAlert>
//             )
//                 : null}
//         </div>
//     );
// }
export default DPAlert;